import type { IPopupConfig } from "@/models";
import type { PopupActions } from "./popup-actions";

export function pushPopup(config: IPopupConfig, actions: PopupActions) {
  actions.pushPopup(config);
}

export function popPopup(id: string | null, actions: PopupActions) {
  actions.popPopup(id);
}
